import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector } from '@xstate/react';
import pageScrollToTop from '../../helpers/pageScrollToTop';
import { AutopayBannerProvider } from '../../hooks/machines/useAutopayBannerMachine';
import { PaymentFlowProvider } from '../../hooks/machines/usePaymentFlowMachine';
import { PaymentMethodProvider } from '../../hooks/machines/usePaymentMethodMachine';
import { PaddedSlideInModalLoader } from '../atoms/styled/PaddedSlideInModalLoader';
import { CardError } from '../molecules/ErrorComponents/CardError';
import AutopayBanner from '../molecules/PaymentModalStates/autopayBanner/AutopayBanner';
import PaymentNotAllowed from './NonPaymentFlow/PaymentNotAllowed';
import PaymentFlow from './PaymentFlow';
import { AddPaymentMethod, ManagePaymentMethod } from './PaymentMethodFlow';
const ModalContent = ({ headerRef, mainService }) => {
    const mainMachineState = useSelector(mainService, (state) => state);
    const [currentPaymentFlow, paymentMethodActorRef] = useSelector(mainService, (state) => [
        state.context.currentPaymentFlow,
        state.context.paymentMethodActorRef
    ]);
    const autopayBannerActorRef = useSelector(mainService, (state) => state.context.autopayBannerRef);
    const [paymentType] = currentPaymentFlow;
    const resetTabFocus = () => {
        var _a;
        (_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        pageScrollToTop('.PaymentModal');
    };
    useEffect(() => {
        const subscription = mainService.subscribe((state) => {
            if (state.changed) {
                resetTabFocus();
            }
        });
        return subscription.unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (mainMachineState.matches('open.initializing')) {
        return _jsx(PaddedSlideInModalLoader, {});
    }
    if (mainMachineState.matches('open.error')) {
        return _jsx(CardError, {});
    }
    if (mainMachineState.matches('open.paymentNotAllowed')) {
        const mainMachineCurrentState = mainMachineState.value;
        return currentPaymentFlow[0] === 'pending' ? (_jsx(PaymentFlowProvider, Object.assign({ value: currentPaymentFlow }, { children: _jsxs(AutopayBannerProvider, Object.assign({ value: autopayBannerActorRef }, { children: [_jsx(AutopayBanner, {}), _jsx(PaymentNotAllowed, { mainMachineCurrentState: mainMachineCurrentState })] })) }))) : (_jsx(PaymentNotAllowed, { mainMachineCurrentState: mainMachineCurrentState }));
    }
    if (mainMachineState.matches('open.paymentFlow')) {
        return (_jsx(PaymentFlowProvider, Object.assign({ value: currentPaymentFlow }, { children: _jsxs(AutopayBannerProvider, Object.assign({ value: autopayBannerActorRef }, { children: [_jsx(AutopayBanner, {}), _jsx(PaymentFlow, { paymentType: paymentType, resetTabFocus: resetTabFocus })] })) })));
    }
    if (mainMachineState.matches('open.managePaymentMethod')) {
        const { managePaymentMethod } = mainMachineState.children;
        return (_jsx(PaymentFlowProvider, Object.assign({ value: currentPaymentFlow }, { children: _jsx(PaymentMethodProvider, Object.assign({ value: paymentMethodActorRef }, { children: managePaymentMethod ? _jsx(ManagePaymentMethod, {}) : _jsx(AddPaymentMethod, {}) })) })));
    }
    return null;
};
export default ModalContent;
